import { type ErrorResponse, onError } from '@apollo/client/link/error';
import { datadogRum } from '@datadog/browser-rum';
import type { ServerError } from '@apollo/client';

const errorLink = onError(({ graphQLErrors, networkError }: ErrorResponse): void => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) =>
      datadogRum.addError(new Error(`[GraphQL error]: Message: ${message}`), { locations, path })
    );
  }

  if (networkError) {
    datadogRum.addError(new Error(`[Network error]: ${networkError}`));

    if ('result' in networkError) {
      const serverError = networkError as ServerError;

      if (401 === serverError?.statusCode) {
        const redirect = `${serverError.response.headers.get('location')}?redirect=${window.location.href}`;
        if (redirect) {
          window.location.assign(redirect);
          return;
        }
      }
    }
  }
});

export default errorLink;
